<template>
  <div class="container">
    <div class="content">
      <h2>🚗 Steering Your Financial Journey: Finance, Lease, or Own? 🚗 </h2>
      <p><br>So, you've got a set of wheels—or maybe you're eyeing your dream ride. But here's the million-dollar question (or maybe just a few-thousand-dollar one): Did you finance, lease, or buy it outright? Let's break down these options in a way even a cat chasing a laser pointer could understand!</p>

      <div class="option" @click="selectOption('finance')" :class="{ selected: isSelected('finance') }">
        <span class="icon">🚗 </span>
        <b> Financed Feline 🐾</b>
       <br> The Deal: You took out a loan and are paying it off in installments.
          Smart Money Says: This is like adopting a kitten and watching it grow. It's yours, but you've got responsibilities—like monthly payments and interest.
          Why It Matters: You're building equity in the car, but remember, it's a depreciating asset. Make sure those monthly payments fit snugly within your budget.
      </div>

      <div class="option" @click="selectOption('lease')" :class="{ selected: isSelected('lease') }">
        <span class="icon">🏢</span>
        
        <b>Leasing Lynx 🐱</b>  <br>The Deal: You're essentially renting the car for a set period.
          Smart Money Says: This is like having a cat visit your home for cuddles but then leave. You enjoy the perks without long-term commitment—but no equity either.
          Why It Matters: Leasing can offer lower monthly payments and lets you switch to a new model frequently. However, you'll always have a car payment and usually have mileage limits.
      </div>

      <div class="option" @click="selectOption('own')" :class="{ selected: isSelected('own') }">
        <span class="icon">😸</span>
        <b>Outright Owner 🦁</b><br>
        The Deal: You paid for the car in full, upfront. No loans, no strings.
          Smart Money Says: This is like adopting a senior cat. It's all yours, no questions asked, and you're free from the monthly financial furballs.
          Why It Matters: Owning outright means zero monthly payments and full control over the car's future—sell it, keep it, or even turn it into an art project (just kidding, please don't).
      </div>

      <br><br>So which lane are you cruising in—Finance, Lease, or Own? Your choice can make a real difference in your monthly cash flow, something we will explore in depth very soon.  <br><br>
    
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    const selectOption = (option) => {
      // Set the selected option directly
      store.updateFormData({ car: option });
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.car === option;

    return { store, selectOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>